import {
  IArchive, INode, HierarchyLevelType,
} from 'common/interfaces/hierarchy-entities';
import { IHierarchyTreeItem } from 'client/views/explore/hierarchy/hierarchy.interfaces';

export const combineCompanyData = (
  archives: IArchive[],
  nodes: INode[],
) => {
  const items: IHierarchyTreeItem[] = [];
  archives.forEach((archive) => {
    items.push({
      id: archive.archiveid,
      ...archive,
      metadata: {
        created: archive.created,
        updated: archive.updated,
      },
      nodeId: archive.nodeid,
      parentId: '',
      entityType: HierarchyLevelType.Archive,
    });
  });
  nodes.forEach((node) => {
    items.push({
      id: node.nodeid,
      ...node,
      metadata: {
        created: node.created,
        updated: node.updated,
      },
      parent: node.parentid,
      parentId: node.parentid || '',
      entityType: HierarchyLevelType.Node,
    });
  });

  return items;
};
